import { commonErr } from "../components/common/errors";
import moment from 'moment';

const initialState = {
	err: commonErr.INNIT,
	errMsg: '',
	detail: undefined,
}

export default function CarCSRed(csDetail = {

		err: commonErr.INNIT,
		booking: {
			address: "Hồ Chí Minh",
			lat: 10.77959710316263,
			lon: 106.6675657995176,
			startDate: moment().add(3, 'days').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			endDate: moment(moment().add(3, 'days').valueOf()).add(1, 'months').set({
				hour: 0,
				minute: 0,
				second: 0,
				milliseconds: 0,
			}),
			timeCS: 6
		},


	}, action) {

	switch (action.type) {

		case "SET_BOOKING_CS": {
			return {
				...csDetail,
				booking: action.payload,
			};
		}

		
		case "GET_CS_DETAIL_PENDING": {
			return {
					...csDetail,
				err: commonErr.LOADING
			}
		}
		case "GET_CS_DETAIL_REJECTED": {
			return {
					...csDetail,
					err: commonErr.FAIL
			}
		}
			
		case "GET_CS_DETAIL_FULFILLED": {
				
			const data = action.payload.data.data;
            const errorMessage = action.payload.data.errorMessage
            const errorCode = action.payload.data.error
			if (data) {
			
            return {
                    ...csDetail,
                    err: commonErr.SUCCESS,
                    errorCode: errorCode,
                    errMsg: errorMessage,
                    detail: {
                        info: data.car,
                        startTime: data.startTime,
                        endTime: data.endTime, 
                        dateNotAvail: data.dateNotAvail
						
                    }
            }
		}
			
		}
		default:
			return csDetail;
	}
}